export const PAYMENT_METHODS = [
  "Debit Card", "Credit Card", "Cash", "Direct Debit",
  "Bank Transfer", "PayPal", "Other",
];

export const FREQUENCIES = ["Weekly", "Fortnightly", "Monthly", "Quarterly", "Annual", "Custom"];

export const CUSTOM_SCHEDULE_TYPES = {
  NTH_WEEKDAY: "nth-weekday-of-month",
  EVERY_N_WEEKS: "every-n-weeks",
};

export const WEEKDAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const NTH_LABELS = { 1: "1st", 2: "2nd", 3: "3rd", 4: "4th", "-1": "Last" };

export const DEFAULT_DATA = {
  txns: [],
  budgets: {},
  bills: [],
  cats: {
    income: [
      "Gustavo's Salary (Net)", "Caroline's Income (Net)",
      "YouTube Revenue", "Side Projects / Freelance", "Other Income",
    ],
    expense: {
      "Housing": ["Rent", "Electricity", "Gas", "Water", "Internet", "Home Insurance / Contents"],
      "Transport": ["Fuel", "Car Insurance", "Rego / CTP", "Car Maintenance", "Public Transport", "Tolls / Parking"],
      "Groceries & Food": ["Groceries", "Dining Out / Takeaway", "Coffee / Snacks"],
      "Health": ["Health Insurance", "Medical / GP", "Dental", "Pharmacy", "Gym / Fitness"],
      "Baby / Child": ["Nappies / Wipes", "Baby Food / Formula", "Childcare", "Clothing (Baby)", "Toys / Activities"],
      "Personal": ["Clothing (Adults)", "Haircuts / Grooming", "Subscriptions", "Phone Plans"],
      "Savings & Goals": ["Home Deposit Savings", "Emergency Fund", "Investment / Super Top-up"],
      "Debt": ["Credit Card Repayment", "Personal Loan", "Other Debt"],
      "Entertainment": ["Activities / Outings", "Hobbies", "Gifts"],
      "Other": ["Miscellaneous", "Unexpected Expenses"],
    },
  },
  savings: { goals: {} },
  netWorth: { assets: {}, liabilities: {}, history: {} },
  shoppingLists: {},
  settings: {
    budgetMode: "standard",
    currency: "$",
    darkMode: false,
    defaultPayment: "Debit Card",
    displayNames: {},
  },
};

/** Derive a display name from an email address (capitalize first part before @). */
export const nameFromEmail = (email) => {
  if (!email) return "User";
  const p = email.split("@")[0];
  return p.charAt(0).toUpperCase() + p.slice(1);
};
